import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CreditCard, Smartphone } from "lucide-react";
import api from "../lib/api";

const inputCls =
  "mt-2 w-full rounded-2xl border border-line bg-cream px-5 py-4 text-base text-ink placeholder:text-inkSoft/50 transition-[border-color] duration-200 focus:border-marmalade focus:outline-none";

const AdminPaymentSettings = () => {
  const [venmoHandle, setVenmoHandle] = useState("");
  const [zelleInfo, setZelleInfo] = useState("");
  const [saving, setSaving] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .get("/payment-settings")
      .then((r) => {
        setVenmoHandle(r.data.venmo_handle || "");
        setZelleInfo(r.data.zelle_info || "");
        setLoaded(true);
      })
      .catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    if (!loaded) return;
    setSaving(true);
    try {
      const { data } = await api.put("/payment-settings", { venmo_handle: venmoHandle, zelle_info: zelleInfo });
      toast.success(data.venmo_handle || data.zelle_info ? "Payment details saved — they now show on the pay page." : "Saved — manual payment options are now hidden.");
    } catch {
      toast.error("Could not save — please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={save} className="h-fit rounded-3xl border border-line bg-white p-8" data-testid="admin-payment-settings">
      <h3 className="flex items-center gap-2 font-display text-2xl font-medium text-ink">
        <CreditCard className="h-5 w-5 text-marmalade" />
        Venmo & Zelle details
      </h3>
      <p className="mt-2 text-sm leading-relaxed text-inkSoft">
        Card and Apple Pay are automatic. Add your own handles so owners can also pay you straight from their
        banking apps — leave blank to hide them.
      </p>
      <label className="mt-6 block">
        <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.22em] text-inkSoft">
          <Smartphone className="h-3.5 w-3.5 text-marmalade" />
          Venmo handle
        </span>
        <input
          value={venmoHandle}
          onChange={(e) => setVenmoHandle(e.target.value)}
          placeholder="@ArisHappyTails"
          data-testid="payment-settings-venmo"
          className={inputCls}
        />
      </label>
      <label className="mt-4 block">
        <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-inkSoft">Zelle (phone or email)</span>
        <input
          value={zelleInfo}
          onChange={(e) => setZelleInfo(e.target.value)}
          placeholder="(555) 010-PAWS or ari@…"
          data-testid="payment-settings-zelle"
          className={inputCls}
        />
      </label>
      <button
        type="submit"
        disabled={saving || !loaded}
        data-testid="payment-settings-save"
        className="mt-6 w-full rounded-full bg-forest py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-cream transition-[background-color] duration-300 hover:bg-ink disabled:opacity-60"
      >
        {saving ? "Saving…" : loaded ? "Save payment details" : "Loading your details…"}
      </button>
    </form>
  );
};

export default AdminPaymentSettings;
